import { z } from 'zod';
/** No session — the login screen and the app shell both need this before
 * (or regardless of) authentication to paint the right logo/colour, and v1
 * is single-tenant so there's no ambiguity about whose branding to serve
 * (docs/architecture/10-risks-and-decisions.md § A9). Only what's safe to
 * show an anonymous visitor crosses this boundary; `supportEmail` stays
 * admin-only. */
export const publicBrandingResponseSchema = z.object({
    productName: z.string(),
    workspaceName: z.string(),
    accentColor: z.string(),
    loginHeadline: z.string().nullable(),
    loginSubtext: z.string().nullable(),
    showPoweredBy: z.boolean(),
    logoUrl: z.string().nullable(),
    logoDarkUrl: z.string().nullable(),
    faviconUrl: z.string().nullable(),
});
//# sourceMappingURL=branding.js.map